export class ProgressBarController {}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/progress-bar/progress-bar.controller.ts